import { gql } from "@apollo/client";

export const GetHeroImage = gql`
  query getHeroImage($eventId: Int!) {
    getHeroImage(event_id: $eventId)
  }
`;

export const GetEventStreamers = gql`
  query getEventStreamers($eventId: Int!) {
    getEventStreamers(eventId: $eventId) {
      Id
      is_streaming
      playback_url
      deviceName
      viewingUrl
      event {
        event_preference {
          live_hall
          private
        }
      }
    }
  }
`;

export const EventBySlug = gql`
  query eventBySlug($slug: String!) {
    eventBySlug(slug: $slug) {
      welcome_msg
      slug
      id
      uuid
      name
      hash_tag
      template_id
      date
      pass_image
      event_parts {
        time
        city
        state
        country
      }
      eventTimezone
      event_preference {
        access_control
        plus_one_request
      }
      event_wallet {
        currency
      }
      available_gift_payment_currencies {
        currency
        provider
        sub_account_id
        sub_account_code
      }
      hero_image_thumbnail
    }
  }
`;

export const EventParts = gql`
  query eventParts($eventId: Int!) {
    eventParts(event_id: $eventId) {
      id
      name
      part
      time
      city
      address
      map_coordinate
      geo_position {
        geo_position_id
        latitude
        longitude
      }
      eventPartTimezone
    }
  }
`;

export const Refresh = gql`
  query refresh($refreshToken: String!) {
    refresh(refresh_token: $refreshToken) {
      access_expiry
      access_token
      refresh_expiry
      refresh_token
      user {
        first_name
        id
        email
        last_name
        phone_number
        verified
      }
    }
  }
`;

export const GetBackStory = gql`
  query getBackStory($eventId: Int!) {
    getBackStory(event_id: $eventId) {
      id
      role
      story
      title
      image
      event_id
    }
  }
`;

export const InvitationCard = gql`
  query invitationCard($eventId: Int!) {
    invitationCard(event_id: $eventId) {
      id
      static_image
    }
  }
`;

export const GetAlbumDetails = gql`
  query getAlbumDetails($eventUuid: String!, $page: Int, $pageSize: Int) {
    getMedia(
      event_id: $eventUuid
      filter: { page: $page, pageSize: $pageSize }
    ) {
      id
      url
      meta {
        s3_url
        height
        width
      }
      type
    }
  }
`;

export const GetWishListItems = gql`
  query getWishListItems($eventId: UUID!, $page: Int, $pageSize: Int) {
    getWishListItems(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      name
      image
      link
      paid
      amount
      currency
      qty
    }
  }
`;

export const GetEventPreferences = gql`
  query Event_preferences($eventId: UUID!) {
    event_preferences(event_id: $eventId) {
      id
      event_id
      food
      ads
      asoebi_selection
      gifts
      store
      vendor_store
      reservation
      access_control
      dress_code
      map
      smart_send
      private
      live_hall
      guest_pov_default_public
      gift_in_invitation
      website_after_invitation
      faq
      recommendations
      plus_one_request
      created_at
      updated_at
    }
  }
`;

export const GetApprovedMessages = gql`
  query getApprovedMessages($eventId: Int!) {
    getApprovedMessages(event_id: $eventId) {
      id
      content
      status
    }
  }
`;

export const EventVendor = gql`
  query eventVendor($eventId: Int!, $page: Int, $pageSize: Int) {
    eventVendor(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      name
      instagram_handle
      phone_number
      role
      email
    }
  }
`;

export const GetForeignWalletDetails = gql`
  query getForeignAccountDetails($eventId: Int!) {
    getForeignAccountDetails(event_id: $eventId) {
      event_id
      account_number
      bank_name
      currency
      beneficiary_name
      swift_code
      country
      city
      bank_address
      post_code
      sort_code
    }
  }
`;

export const GetLiveSchedule = gql`
  query getLiveSchedule($eventUuid: String!, $page: Int, $pageSize: Int) {
    getLiveSchedule(eventUuid: $eventUuid, page: $page, pageSize: $pageSize) {
      page
      pageSize
      pageCount
      recordCount
      data {
        id
        event_uuid
        event_part_uuid
        link
        time
        created_at
        updated_at
        event_part {
          id
          name
          uuid
        }
      }
    }
  }
`;

export const GetAsoEbi = gql`
  query GetAseobi($event_id: UUID!) {
    getAseobi(event_id: $event_id) {
      id
      name
      description
      status
      currency_iso
      deadline
    }
  }
`;

export const GetAsoEbiAttires = gql`
  query GetAseobiAttires($event_id: UUID!, $aseobi_id: UUID!) {
    getAseobiAttires(event_id: $event_id, aseobi_id: $aseobi_id) {
      id
      aseobi_id
      name
      note
      images
      description
      currency_iso
      size_unit
      total_price_per_yard
      vendor
      vendor_product_id
      active
      aseobi {
        name
        status
      }
      minimum_purchase_quantity
    }
  }
`;

export const GetProfileDetails = gql`
  query user {
    user {
      id
      uuid
      gender
      first_name
      last_name
      email
      phone_number
      image
    }
  }
`;

export const GetEvent = gql`
  query event($eventId: Int!) {
    event(event_id: $eventId) {
      id
      slug
      pass_image
      event_preference {
        access_control
        plus_one_request
      }
      supported_currencies {
        currency
        providers
      }
    }
  }
`;

export const DescribeAseobiFeePercentage = gql`
  query DescribeAseobiFeePercentage($eventID: UUID!) {
    describeAseobiFeePercentage(eventID: $eventID)
  }
`;

export const GetWeddingParty = gql`
  query getWeddingParty($eventId: UUID!) {
    getWeddingParty(event_id: $eventId) {
      id
      first_name
      last_name
      nickname
      order_index
      role
      story
      image_url
      event_id
    }
  }
`;

export const IsInvitedToEvent = gql`
  query isInvitedToEvent($eventId: UUID!) {
    isInvitedToEvent(event_id: $eventId)
  }
`;

export const GET_FAQS_BY_EVENT = gql`
  query GetFAQsByEvent($eventId: UUID!, $filter: FAQFilter!) {
    getFAQsByEvent(event_id: $eventId, filter: $filter) {
      page
      pageSize
      pageCount
      recordCount
      data {
        id
        event_id
        event_part_id
        question
        answer
        order_index
        is_active
        created_at
        updated_at
      }
    }
  }
`;

export const GET_FAQ = gql`
  query GetFAQ($id: UUID!) {
    getFAQ(id: $id) {
      id
      event_id
      event_part_id
      question
      answer
      order_index
      is_active
      created_at
      updated_at
    }
  }
`;

export const EVENT_WISHLIST_NOTE = gql`
  query EventWishlistNote($eventId: Int!) {
    eventWishlistNote(event_id: $eventId)
  }
`;

export const GetEventRecommendationLists = gql`
  query GetEventRecommendationLists($eventId: UUID!) {
    getEventRecommendationLists(eventId: $eventId) {
      id
      name
      category
      description
      items {
        id
        name
        description
        contactInfo
        link
        mediaUrl
        mediaType
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const MY_PLUS_ONE_REQUESTS = gql`
  query MyPlusOneRequests($eventId: UUID!, $invitationId: UUID!) {
    myPlusOneRequests(event_id: $eventId, invitation_id: $invitationId) {
      id
      invitation_id
      status
      guest_email
      guest_first_name
      guest_last_name
      guest_phone
      created_at
    }
  }
`;
